import React, { useState } from "react";
import { useTranslation } from 'react-i18next';

interface FailedInspectionProps {
  onChange: (value: boolean | null) => void;
}

const FailedInspection: React.FC<FailedInspectionProps> = ({ onChange }) => {
  const { t } = useTranslation('vehicle');
  const [isChecked, setIsChecked] = useState<boolean | null>(null);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    const value = checked ? false : null;
    setIsChecked(value);
    onChange(value);
  };

  return (
    <div>
      <label className="flex flex-row gap-2">
        <input
          type="checkbox"
          checked={isChecked !== null}
          onChange={handleCheckboxChange}
        />
          <p>{t('inspection-record.table.failed-inspection')}</p>
      </label>
    </div>
  );
};

export default FailedInspection;